import { FC, SVGProps } from "react";

const RelationshipIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="58"
      height="53"
      viewBox="0 0 58 53"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle
        opacity=".3"
        cx="14.5"
        cy="14.5"
        r="14.5"
        transform="matrix(1 0 0 -1 29 29)"
        fill="#4BB1E9"
      />
      <path
        d="M17.785 24.07c-.443 0-.823-.072-1.14-.217a1.688 1.688 0 0 1-.736-.637c-.173-.28-.268-.628-.287-1.043a25.694 25.694 0 0 1 0-1.246c.019-.406.117-.749.294-1.029.177-.285.425-.5.742-.644.317-.15.693-.224 1.127-.224.308 0 .593.04.854.119.262.075.49.187.686.336.196.145.348.322.455.532a1.5 1.5 0 0 1 .175.7.114.114 0 0 1-.042.105.142.142 0 0 1-.105.042h-.945a.24.24 0 0 1-.14-.035.33.33 0 0 1-.084-.147c-.065-.247-.172-.415-.322-.504a.975.975 0 0 0-.539-.14c-.256 0-.46.072-.609.217-.15.14-.23.376-.245.707-.014.383-.014.775 0 1.176.014.331.096.57.245.714.15.14.352.21.61.21.214 0 .396-.047.545-.14.15-.093.254-.261.315-.504.019-.07.044-.117.077-.14a.24.24 0 0 1 .147-.042h.945c.042 0 .077.014.105.042a.114.114 0 0 1 .042.105 1.538 1.538 0 0 1-.175.707 1.593 1.593 0 0 1-.455.532 2.237 2.237 0 0 1-.686.336 3.098 3.098 0 0 1-.854.112Zm3.081-.07a.17.17 0 0 1-.126-.049.17.17 0 0 1-.049-.126v-4.55a.17.17 0 0 1 .05-.126.17.17 0 0 1 .125-.049h.924c.047 0 .087.016.12.049a.16.16 0 0 1 .055.126v3.668h2.114a.16.16 0 0 1 .126.056.16.16 0 0 1 .056.126v.7a.16.16 0 0 1-.056.126.17.17 0 0 1-.126.049h-3.213Zm3.722 0a.159.159 0 0 1-.105-.042.159.159 0 0 1-.042-.105c0-.023.002-.044.007-.063l1.645-4.494a.27.27 0 0 1 .084-.133.272.272 0 0 1 .189-.063h1.036c.08 0 .14.021.182.063a.254.254 0 0 1 .09.133l1.639 4.494c.01.019.014.04.014.063a.147.147 0 0 1-.05.105.142.142 0 0 1-.104.042h-.861c-.07 0-.124-.016-.161-.049a.31.31 0 0 1-.063-.098l-.273-.714h-1.87l-.265.714a.306.306 0 0 1-.063.098c-.033.033-.089.049-.168.049h-.861Zm1.645-1.869h1.302l-.658-1.848-.644 1.848ZM30.053 24a.17.17 0 0 1-.125-.049.17.17 0 0 1-.05-.126v-4.55a.17.17 0 0 1 .05-.126.17.17 0 0 1 .126-.049h.938a.17.17 0 0 1 .126.049.17.17 0 0 1 .049.126v4.55a.17.17 0 0 1-.05.126.17.17 0 0 1-.125.049h-.938Zm2.27 0a.186.186 0 0 1-.126-.049.17.17 0 0 1-.049-.126v-4.55a.17.17 0 0 1 .05-.126.186.186 0 0 1 .125-.049h.756c.075 0 .13.021.168.063a.289.289 0 0 1 .077.091l1.232 2.212 1.232-2.212a.685.685 0 0 1 .07-.091c.038-.042.096-.063.175-.063h.75a.17.17 0 0 1 .125.049.16.16 0 0 1 .056.126v4.55a.16.16 0 0 1-.056.126.17.17 0 0 1-.126.049h-.833a.195.195 0 0 1-.133-.049.17.17 0 0 1-.049-.126V21.2l-.79 1.463a.323.323 0 0 1-.085.112.226.226 0 0 1-.154.049h-.364a.226.226 0 0 1-.154-.049.418.418 0 0 1-.09-.112l-.792-1.463v2.625a.17.17 0 0 1-.049.126.17.17 0 0 1-.126.049h-.84Z"
        fill="#2C2C2C"
      />
      <path
        d="M31.785 52H13.714a3 3 0 0 1-3-3V15.714a3 3 0 0 1 3-3h25.428a3 3 0 0 1 3 3v23.429"
        stroke="#2C2C2C"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
      <path
        d="M10.714 47.714.976 18.557a3 3 0 0 1 1.97-3.82L25.42 7.884a3 3 0 0 1 3.753 2.022L30 12.714"
        stroke="#2C2C2C"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
      <path
        d="M43.571 45.763v.526a5.715 5.715 0 1 1-3.388-5.223"
        stroke="#2C2C2C"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="m43.572 42-5.495 5.714-1.648-1.712"
        stroke="#2C2C2C"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="16.929"
        y="28.929"
        width="19.714"
        height="5.429"
        rx="1.5"
        stroke="#2C2C2C"
        strokeLinejoin="round"
      />
      <path
        stroke="#2C2C2C"
        strokeLinecap="round"
        d="M17.643 37.929H34.5m-16.857 2.857h14m-14 2.857h11.142M17.643 46.5h11.142"
      />
    </svg>
  );
};

export default RelationshipIcon;
